// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ef604f8f","453":"a6dc960b","732":"1908a570","977":"6935a91b"}[chunkId] + ".chunk.js";
};